<template>
    <MainContainer>
        <div class="buchungsstapel">
            <h2 class="my-2">
                Buchungsstapel-Übersicht
                <b-button
                    :size="size"
                    :to="{ path: '/fibu/buchungsstapel/new' }"
                >
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>

            <Table
                bordered
                striped
                small
                showFilter
                tableClass="buchungsstapel-list"
                :responsive="true"
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt Buchungsstapel-Daten..."
                emptyText="Bisher wurden keine Buchungsstapel generiert..."
            >
                <template v-slot:head(id)>ID</template>

                <template v-slot:head(description)>Bezeichnung</template>

                <template v-slot:id="{ row: row }">
                    {{ row.item.id }}
                </template>

                <template v-slot:description="{ row: row }">
                    {{ row.item.description }}
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-dropdown text="Aktionen" :size="size" dropleft>
                        <b-dropdown-item
                            :to="{ path: `/fibu/buchungsstapel/verwalten/${row.id}` }"
                        >
                            Buchungsstapel verwalten
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="row.hasVorlagen"
                            :to="{ path: `/fibu/buchungsstapel/buchen/${row.id}` }"
                        >
                            Buchungsstapel buchen
                        </b-dropdown-item>
                    </b-dropdown>
                    <b-button
                        :size="size"
                        variant="link"
                        class="mv-table-action-btn mr-1"
                        :to="{ path: '/fibu/buchungsstapel/' + row.id }"
                    >Umbenennen</b-button
                    >
                    <b-button
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button
                    >
                </template>
            </Table>
        </div>
        <RemoveModal
            :title="selected.title"
            :busy="selected.busy"
            @ok="dataProvide"
            @hide="dataHide"
        />
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import Table from "@/components/Table/Table";
import {ApiFactory} from "@/api/ApiFactory";
import RemoveModal from "@/components/RemoveModal/RemoveModal";

const FiBuBuchungsstapelApi = ApiFactory.get('fibuBuchungsstapel');

export default {
    name: "Buchungsstapel",
    mixins: [CommonView, Size, Validation],
    components: {
        MainContainer,
        Table,
        RemoveModal
    },
    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    class: 'text-left'
                },
                {
                    key: 'description',
                    label: 'Bezeichnung',
                    class: 'text-left',
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-left"
                }
            ],
            busy: false,
            api: FiBuBuchungsstapelApi,
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch() {
            // FiBuBuchungsstapelApi.abort();
            this.busy = true;

            const response = await FiBuBuchungsstapelApi.get();

            if(response.ok) {
                this.registerRights(response);
                let items = response.json.collection;
                if(items) {
                    this.items = items;
                } else {
                    this.items = [];
                }
            }

            this.busy = false;
        }
    }
}
</script>